import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { LOCALES } from "lang";
import { useSelector } from "react-redux";
// import { YAxis } from "recharts";

const useExportToPDF = () => {
  const currentLocale = useSelector(({ theme }) => theme.locale);
  // function base64ToArrayBuffer(base64) {
  //   var binaryString = atob(base64);
  //   var bytes = new Uint8Array(binaryString.length);
  //   for (var i = 0; i < binaryString.length; i++) {
  //       bytes[i] = binaryString.charCodeAt(i);
  //   }
  //   return bytes.buffer;
  // }
  const exportPDF = ({
    ref,
    allowLogo = true,
    fileName = "filename",
    headerTitle = null,
  }) => {
    const element = ref.current;

    html2canvas(element, {
      logging: true,
    })
      .then(async (canvas) => {
        const titleFontSize = 16;
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgY = 5;
        const canvasWidth = imgWidth * ratio - 10;
        const canvasHeight = imgHeight * ratio;
        const marginX = (pdfWidth - canvasWidth) / 2;
        const lineHeight = 7; // Adjust according to your requirements
        const logoXStartingPoint =
          currentLocale === LOCALES.ARABIC ? pdfWidth - 75 : 2;
        const logoWidth = 70;
        const logoHeight = 20;
        let marginY = allowLogo ? logoHeight + 7 : imgY;
        // const FONT_PATH = `${process.env.PUBLIC_URL}/font/Tajawal-Regular.ttf`;

        // const fontFileResponse = await fetch(FONT_PATH);

        // const arrayBuffer = base64ToArrayBuffer(TajawalFontString);

        //const fontFileContentsBuffer = await fetch(FONT_PATH);
        // pdf.addFont(arrayBuffer, "Tajawal", "normal");
        pdf.setFont("Tajawal", "normal");
        {
          allowLogo &&
            pdf.addImage(
              process.env.PUBLIC_URL + "/image/pdfHeader.png",
              "PNG",
              2,
              imgY,
              206,
              logoHeight
            );
          pdf.addImage(
            process.env.PUBLIC_URL + "/image/pdfFooter.png",
            "PNG",
            2,
            280,
            206,
            15
          );
        }
        // if (headerTitle) {
        //   const lines = pdf.splitTextToSize(headerTitle, pdfWidth);

        //   marginY += 10;
        //   for (const line of lines) {
        //     const lineWidth =
        //       pdf.getStringUnitWidth(line) * titleFontSize * 0.3527;
        //     const startX =
        //       currentLocale === LOCALES.ARABIC ? pdfWidth - lineWidth - 10 : 5;
        //     pdf.text(line, startX, marginY);
        //     marginY += lineHeight;
        //   }
        // }

        pdf.addImage(
          imgData,
          "PNG",
          marginX,
          marginY,
          canvasWidth,
          canvasHeight
        );
        //newest
        // pdf.setFont("Tajawal", "normal");
        // {
        //   allowLogo &&
        //     pdf.addImage(
        //       process.env.PUBLIC_URL + "/image/logo.png",
        //       "PNG",
        //       logoXStartingPoint,
        //       250,
        //       logoWidth,
        //       logoHeight
        //     );
        // }
        // pdf.addImage(
        //   imgData,
        //   "PNG",
        //   marginX,
        //   marginY,
        //   canvasWidth,
        //   canvasHeight
        // );
        //latest
        pdf.save(`${fileName}.pdf`);
      })
      .catch((e) => {
        //console.log(e);
      });
  };
  return [exportPDF];
};

export default useExportToPDF;
